export function buildCustomizerUI(params, onParamChange) {
  const tabsContainer = document.getElementById("customizer-tabs");
  const contentContainer = document.getElementById("customizer-content");
  tabsContainer.innerHTML = "";
  contentContainer.innerHTML = "";

  if (!params || !params.params || !params.params.vars) {
    contentContainer.innerHTML = '<p class="text-muted">No parameters found.</p>';
    return;
  }

  const vars = params.params.vars;
  const groups = {};
  let noGroup = [];

  for (const [name, def] of Object.entries(vars)) {
    const group = def.group || "_no_group";
    if (group === "_no_group" || !def.group) {
      noGroup.push({ name, ...def });
    } else {
      if (!groups[group]) groups[group] = [];
      groups[group].push({ name, ...def });
    }
  }

  // Build tabs
  const groupNames = Object.keys(groups);
  if (groupNames.length > 0) {
    // "All" tab for no-group params
    if (noGroup.length > 0) {
      const allBtn = document.createElement("button");
      allBtn.textContent = "All";
      allBtn.dataset.tab = "all";
      allBtn.classList.add("active");
      tabsContainer.appendChild(allBtn);
    }
    for (const gName of groupNames) {
      const btn = document.createElement("button");
      btn.textContent = gName;
      btn.dataset.tab = gName;
      tabsContainer.appendChild(btn);
    }

    // Build tab content
    const allTab = document.createElement("div");
    allTab.dataset.tab = "all";
    allTab.classList.add("tab-content");
    if (noGroup.length > 0) {
      allTab.appendChild(createParamFields(noGroup, onParamChange));
    }
    contentContainer.appendChild(allTab);

    for (const gName of groupNames) {
      const tabDiv = document.createElement("div");
      tabDiv.dataset.tab = gName;
      tabDiv.classList.add("tab-content");
      tabDiv.style.display = "none";
      tabDiv.appendChild(createParamFields(groups[gName], onParamChange));
      contentContainer.appendChild(tabDiv);
    }

    // Tab switching
    tabsContainer.addEventListener("click", (e) => {
      if (e.target.tagName !== "BUTTON") return;
      tabsContainer.querySelectorAll("button").forEach(b => b.classList.remove("active"));
      e.target.classList.add("active");
      contentContainer.querySelectorAll(".tab-content").forEach(t => t.style.display = "none");
      const targetTab = e.target.dataset.tab;
      const targetDiv = contentContainer.querySelector(`[data-tab="${targetTab}"]`);
      if (targetDiv) targetDiv.style.display = "block";
    });
  } else {
    // No tabs, just show all params
    contentContainer.appendChild(createParamFields(noGroup, onParamChange));
  }
}

function createParamFields(params, onParamChange) {
  const fragment = document.createDocumentFragment();

  for (const p of params) {
    const field = document.createElement("div");
    field.classList.add("param-group");

    const label = document.createElement("label");
    label.textContent = p.caption || p.name;

    let input;

    if (p.type === "bool") {
      const wrapper = document.createElement("div");
      wrapper.style.display = "flex";
      wrapper.style.alignItems = "center";
      input = document.createElement("input");
      input.type = "checkbox";
      input.checked = !!p.value;
      wrapper.appendChild(input);
      wrapper.appendChild(document.createTextNode(" " + (p.caption || p.name)));
      field.appendChild(wrapper);
    } else if (p.type === "vector") {
      const vecLen = p.value.length || 3;
      input = document.createElement("div");
      input.className = "vector-input";
      input.style.display = "flex";
      input.style.gap = "0.25rem";
      input.style.flexWrap = "wrap";
      input.dataset.paramName = p.name;
      for (let i = 0; i < vecLen; i++) {
        const vInput = document.createElement("input");
        vInput.type = "number";
        vInput.step = p.step || "0.01";
        vInput.min = p.min ?? "";
        vInput.max = p.max ?? "";
        vInput.value = p.value[i] ?? 0;
        vInput.style.width = "60px";
        vInput.dataset.vecIndex = i;
        vInput.addEventListener("input", () => {
          const vecInputs = input.querySelectorAll("input[type=number]");
          const vec = [];
          for (const vi of vecInputs) vec.push(parseFloat(vi.value));
          onParamChange(p.name, vec);
        });
        input.appendChild(vInput);
      }
    } else if (p.options && p.options.length > 0) {
      input = document.createElement("select");
      for (const opt of p.options) {
        const option = document.createElement("option");
        option.value = opt;
        option.textContent = opt;
        if (String(opt) === String(p.value)) option.selected = true;
        input.appendChild(option);
      }
    } else if (p.type === "number" || p.type === "integer") {
      input = document.createElement("input");
      input.type = p.type === "integer" ? "number" : "number";
      input.step = p.step || (p.type === "integer" ? "1" : "0.01");
      input.min = p.min ?? "";
      input.max = p.max ?? "";
      input.value = p.value;
      input.style.width = "100%";
    } else {
      // String or default
      input = document.createElement("input");
      input.type = "text";
      input.value = p.value;
      input.style.width = "100%";
    }

    input.dataset.paramName = p.name;

    if (p.type !== "bool") {
      label.appendChild(input);
      field.appendChild(label);
    }

    input.addEventListener("input", () => {
      let val = input.value;
      if (input.type === "number") val = parseFloat(val);
      onParamChange(p.name, val);
    });

    if (input.tagName === "SELECT") {
      input.addEventListener("change", () => {
        onParamChange(p.name, input.value);
      });
    }

    fragment.appendChild(field);
  }

  return fragment;
}

export function getParamValues() {
  const values = {};
  document.querySelectorAll("#customizer-content input, #customizer-content select").forEach(el => {
    const name = el.dataset.paramName;
    if (!name) return;
    if (el.type === "checkbox") {
      values[name] = el.checked;
    } else if (el.type === "number") {
      values[name] = parseFloat(el.value);
    } else {
      values[name] = el.value;
    }
  });

  // Handle vector inputs
  document.querySelectorAll("#customizer-content .vector-input").forEach(container => {
    const name = container.dataset.paramName;
    if (!name) return;
    const vecInputs = container.querySelectorAll("input[type=number]");
    const vec = [];
    for (const vi of vecInputs) vec.push(parseFloat(vi.value));
    values[name] = vec;
  });

  return values;
}